import { useCallback, useState } from 'react';
import {
  OpenMeetingRegistrationOptions,
  OpenMeetingRegistrationResult,
  registerForOpenMeeting
} from '../lib/services/open-meeting-registration/open-meeting-registration';
import { isAudienceCapacityEnabled } from '../lib/helpers/openMeetingRegistrationHelper';

export type UseOpenMeetingRegistrationResult = {
  isLoading: boolean;
  register: (
    eventId: string,
    meetingId: string,
    options?: OpenMeetingRegistrationOptions
  ) => Promise<OpenMeetingRegistrationResult>;
};

export const useOpenMeetingRegistration = (): UseOpenMeetingRegistrationResult => {
  const [isLoading, setIsLoading] = useState(false);

  const register = useCallback(async (
    eventId: string,
    meetingId: string,
    options?: OpenMeetingRegistrationOptions
  ): Promise<OpenMeetingRegistrationResult> => {
    const showLoading = isAudienceCapacityEnabled(options?.audienceCapacityEnabled);
    if (showLoading) {
      setIsLoading(true);
    }
    try {
      return await registerForOpenMeeting(eventId, meetingId, options);
    } finally {
      if (showLoading) {
        setIsLoading(false);
      }
    }
  }, []);

  return { isLoading, register };
};
